import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, flatMap, map, switchMap } from 'rxjs/operators';
import { MultiLangPipe } from 'src/app/pipes/multi-lang.pipe';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-list-autocomplete',
  templateUrl: './list-autocomplete.component.html',
  styleUrls: ['./list-autocomplete.component.scss'],
})
export class ListAutocompleteComponent implements OnInit {
  @Input() $list=null;
  @Input() config;
  @Input() model? = null;
  @Output() onSelectedEvent = new EventEmitter<any>();



  public options:Array<any> = []; 
  public isLoading: boolean = true;
  public selected;
  public typeahead$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public searchTerm: string;
  public totalItems = 0;
  public $listCode = null;
  public limit = 100;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private multiLangPipe: MultiLangPipe
  ) { }

  ngOnInit() {
   
    if(this.$list) {
     
      const tempArr = this.$list.split('/');
      if(tempArr.length) {
        this.$listCode = tempArr.pop();
      }

    }

    this.setupTypeahead(this.model);


  }


  /**
   * Setup list autocomplete typeahead handler
   * @author Neil C
   * @param model 
   */
  setupTypeahead(model?) {
    this.typeahead$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term) => {
          
          this.searchTerm = term;
          this.isLoading = true;
          return this.get(0,term);
         
        }))
      .subscribe((data: Array<any> = []) => {
        this.isLoading = false;
        this.options = [...data];


        //set selected
        if(model && data.length) {

          //check if model is present in data
          const [selected] = data.filter(({value}) => value === model);
          if(selected) {
            this.selected = {...selected }
          }

        }


      }, (err) => {
        this.isLoading = false;
        this.options = [];
    });
  }

  /**
   * GET list items
   * @param page 
   * @param term 
   * @returns 
   */
  get(page=0, term?) {

    this.isLoading = true;
    let params = new HttpParams()
      .set('page', (++ page).toString())
      .set('items_per_page', `${this.limit}`)

      if (term) {
        params = params.append('query_field', 'listItemName')
        .append('query_value', `.*${term}.*`);
      }

      const endpoint = `${environment.templateApiUrl}list/${this.$listCode}`;
      
      return this.apiService.getByPath(
        endpoint, params, this.authService.accessToken)
        .pipe(
          map(({total_items, data}) => {
            this.totalItems = total_items;
            return data
          }),
          map(({listItem}) => {
         
            try {
              //console.log(listItem)
              return listItem.reduce((acc, {listItemName, listItemCode}) => {
                const label = this.multiLangPipe.transform(listItemName);
                const value = listItemCode;
                acc.push({ label, value })
                return acc;
              },[]);    

            } catch (e) {
              return []
            }

           
        
          }),
          catchError(() => []) );
     

  }

  onSelect($event) {
   
    this.onSelectedEvent.emit(this.selected);

  }

  /**
   * NG-select on scroll to bottom handler
   * @author Neil C 
   * @task QLIKTAG-4053
   */
  onScrollToEnd() {
    //console.log(this.options.length, this.totalItems)
    if(this.options.length < this.totalItems) {
      let page = Math.floor(( this.options.length / this.limit));
      

      this.isLoading = true;

      this.get(page, this.searchTerm)
      .subscribe((data) => {
        this.isLoading = false;
        this.options = [...this.options, ...data];
      }, (err) => {
        this.isLoading = false;
        this.options = [];
      });

    }

  }

}
